import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ExternalLink, Tag } from 'lucide-react';
import { projects } from '../data/mock';
// import imgs from "../../public/project images/Elite Auto Gallery – Phantom VIII Digital Showcase.jpeg"

const Portfolio = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const categories = ['All', ...new Set(projects.map(p => p.category))];

  // console.log(imgs)

  const filteredProjects = selectedCategory === 'All' 
    ? projects 
    : projects.filter(p => p.category === selectedCategory);

  return (
    <section id="portfolio" className="relative py-32 bg-black overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div 
          className="w-full h-full"
          style={{
            backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(0,255,209,0.3) 35px, rgba(0,255,209,0.3) 36px)`
          }}
        />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-[7.6923%]">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <motion.span
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="inline-block text-[#00FFD1] text-lg font-medium mb-4 tracking-wide"
          >
            OUR WORK
          </motion.span>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Featured <span className="text-[#00FFD1]">Projects</span>
          </h2>
          <p className="text-xl text-white/85 max-w-3xl mx-auto leading-relaxed">
            Discover our portfolio of successful projects delivered for clients worldwide
          </p>
        </motion.div>

        {/* Category Filter */}
        
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-wrap justify-center gap-4 mb-16"
        >
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-3 text-base font-medium transition-all duration-400 ${
                selectedCategory === category
                  ? 'bg-[#00FFD1] text-black'
                  : 'bg-white/10 text-white hover:bg-white/20'
              }`}
            >
              {category}
            </button>
          ))}
        </motion.div> */}

        {/* Projects Grid */}
        <motion.div
          layout
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          <AnimatePresence mode="popLayout">
            {filteredProjects.map((project, index) => (
              <motion.div
                key={project.id}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="group relative bg-[#121212] border border-white/25 overflow-hidden transition-all duration-400 hover:border-[#00FFD1]"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    loading='lazy'
                    src={project.image}
                    // src={'project images/'+project.title+'.jpeg'}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  {/* Overlay on Hover */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-400" />
                  
                  {/* Category Badge */}
                  <div className="absolute top-4 left-4 bg-[#00FFD1] text-black px-3 py-1 text-sm font-medium">
                    {project.category}
                  </div>

                  {/* View Project Button */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-400">
                    <a href={project.link}>

                    <button className="bg-[#00FFD1] text-black px-6 py-3 font-medium text-base transition-all duration-400 hover:bg-white flex items-center gap-2">
                      
                      View Project
                      <ExternalLink size={16} />
                    </button>
                    </a>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-white mb-3 leading-tight group-hover:text-[#00FFD1] transition-colors duration-400">
                    {project.title}
                  </h3>
                  <p className="text-white/85 text-base leading-relaxed mb-4">
                    {project.description}
                  </p>

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2">
                    {project.tags.map((tag, idx) => (
                      <span
                        key={idx}
                        className="flex items-center gap-1 text-[#00FFD1] text-sm border border-[#00FFD1]/30 px-3 py-1"
                      >
                        <Tag size={12} />
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};

export default Portfolio;
